import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  const { width, height } = props;
  return (
    <Svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.024 26.022c-6.057 0-10.97.271-10.97.606 0 .334 4.913.606 10.97.606 6.058 0 10.97-.272 10.97-.606 0-.335-4.912-.606-10.97-.606z"
        fill="#D1D3D4"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.746 22.434l.052.642-.867.052-.075-.576.89-.118z"
        fill="#F7B48F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.782 22.872c.288.091.297.81.122 1.018l-.004.004-2.976-.15c-.057-.141.025-.532.333-.7.26-.141 1.023-.18 1.63-.188l.011.02s.235.138.53.115c.289-.023.352-.116.354-.12z"
        fill="#4C4B96"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.689 23.783l-.765-.039c-.057-.141-.092-.506.216-.674.077-.043.315-.1.463-.126a.948.948 0 01.086.839z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.99 23.695a.487.487 0 01-.086.195l-.004.004-2.976-.15a.402.402 0 01-.008-.203l3.075.154z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.142 15.695s.115 1.608-.51 2.048c-.627.44-4.053.145-4.36.081 0 0 .222.708.355 2.06.133 1.35.215 2.578.215 2.578-.195.178-.815.26-1.104.147 0 0-1.1-4.653-1.037-5.34.064-.689.458-.917 1.267-.996.809-.08 3.522-.358 3.522-.358l1.652-.22z"
        fill="#4C4B96"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.411 11.36c.146-.028.31.237.368.592.057.355-.015.666-.162.694-.146.028-.31-.237-.367-.592-.057-.355.015-.666.161-.694z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.607 12.648c-.144.013-.302-.248-.357-.594-.048-.297-.005-.564.096-.66.144-.012.301.248.357.594.048.298.005.565-.096.66z"
        fill="#BCBEC0"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.514 12.003s-.548.3-.6.448c-.052.148-.12.888-.094.932.025.045.105.009.125.006.02-.003.02-.605.085-.82.066-.217.537-.455.537-.455l-.053-.11z"
        fill="#BCBEC0"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.784 12.912c-.007 0-.013.002-.02.003a2.258 2.258 0 00.008 2.15c-.884-.145-.707-2.043.012-2.153z"
        fill="#FFCB05"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.675 22.902a1.27 1.27 0 110 2.54 1.27 1.27 0 010-2.54zm0-1.283a2.553 2.553 0 110 5.105 2.553 2.553 0 010-5.105z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.555 23.574l.514.167a.744.744 0 01.39-.28v-.54a1.272 1.272 0 00-.904.653zm.207 1.48l.318-.438a.74.74 0 01-.148-.445v-.018l-.513-.167a1.276 1.276 0 00.343 1.068zm1.476.255l-.317-.437a.74.74 0 01-.491 0l-.318.437a1.261 1.261 0 001.126 0zm.693-1.323l-.514.167v.018a.74.74 0 01-.147.445l.318.438a1.266 1.266 0 00.343-1.068zm-1.04-1.066v.54a.744.744 0 01.39.281l.515-.167a1.272 1.272 0 00-.904-.654zm-.216-.424a1.675 1.675 0 110 3.35 1.675 1.675 0 010-3.35z"
        fill="#A8AAAA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.675 23.886a.286.286 0 110 .571.286.286 0 010-.571z"
        fill="#5F473D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.552 22.902a1.27 1.27 0 110 2.539 1.27 1.27 0 010-2.54zm0-1.283a2.553 2.553 0 110 5.106 2.553 2.553 0 010-5.106z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.432 23.574l.515.167a.744.744 0 01.389-.28v-.54a1.271 1.271 0 00-.904.653zm.208 1.48l.318-.438a.74.74 0 01-.148-.445v-.018l-.513-.167a1.279 1.279 0 00.343 1.068zm1.475.255l-.317-.437a.74.74 0 01-.49 0l-.318.437a1.261 1.261 0 001.125 0zm.693-1.323l-.513.167v.018a.74.74 0 01-.148.445l.318.438a1.266 1.266 0 00.343-1.068zM7.77 22.92v.54a.744.744 0 01.39.281l.514-.167a1.271 1.271 0 00-.904-.654zm-.216-.424a1.675 1.675 0 110 3.35 1.675 1.675 0 010-3.35z"
        fill="#A8AAAA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.552 23.886a.286.286 0 110 .571.286.286 0 010-.571z"
        fill="#5F473D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.549 19.495h1.106s.39.755.31.951c-.082.197-.45.178-.45.178l-.966-1.129z"
        fill="#FFCB05"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.857 19.312h1.395s.627.955.631 1.33c.004.377-.398.4-.398.4l-1.628-1.73z"
        fill="#A8AAAA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.112 9.52l.445.76c-.008-.001-.832.66-.896.675l-.4-.94.851-.496z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.547 8c-.076 1.748.395 2.717 2.523 1.841l-.166-1.404-.725-.597-1.632.16z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.885 7.426c.662.573 2.313-1.157 2.846-.262 0 0 .563.15.77.67.205.519-.265 1.986-.265 1.986l-.604-.579c.45-.45-.192-.834-.361-.29l-.31-.678c-.668.262-2.09.318-2.076-.847zM16.35 9.66c-.09.269-.2.515-.558.556 0 0 .077.067.17.063.25-.01.48-.191.542-.461l-.155-.157z"
        fill="#262B2C"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.382 7.53c1.365.015 1.814.68 1.78 1.876-.013.453.14.47.55.436 1.413-.117 2.234-2.565.55-3.547-1.424-.83-3.124.254-2.88 1.236z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.382 7.53c1.365.015 1.814.68 1.78 1.876-.013.453.14.47.55.436.18-.015.35-.068.506-.15-.31.047-.659.066-.792-.052-.265-.234.054-1.14-.588-1.823-.433-.461-1.095-.47-1.479-.427.004.046.01.094.023.14z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.77 8.348a.409.409 0 10.003.818.409.409 0 00-.002-.818z"
        fill="#262B2C"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3 13.895s.483-.048.965.027c.483.076 2.512-.505 2.713-.565.2-.06.702-1.297.702-1.297l.85.477s-.79 1.25-1.116 1.446c-.326.196-2.6.455-2.871.476-.272.022-1.214-.126-1.214-.126l-.028-.438z"
        fill="#F7B48F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.416 16.138s.728-1.326.772-1.728c.043-.401-1.25-.793-1.25-.793l-.869 1.869.76.782.587-.13z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.42 21.451s.347.499.912 1.335c.565.837.717 1.206.717 1.206s-.293.185-.89-.423c-.598-.609-1.988-1.467-1.988-1.467l1.25-.65z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.755 20.494c-1.152-.106-3.035.736-3.585 2.042 2.882-.42 3.12.149 4.77 1.271.543.37 1.162.163 1.162.163l-2.347-3.476z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.755 20.494c-.343-.032-.752.021-1.17.145.256.158.503.39.619.724.134.387.184.929.199 1.404.458.244.888.6 1.537 1.04.543.37 1.162.164 1.162.164l-2.347-3.477z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.069 15.486l1.347.652s.12.217-.087.738c-.206.522-.706 1.423-.847 2.51-.141 1.086-.141 3.682 1.119 3.726 1.26.043 2.987.043 2.987.043s.364-.026.63-.172c.265-.147.359-.36.359-.36l4.53-1.217 5.247.055-.022.554s-1.727.434-3.205.727c-1.477.294-1.933.37-1.933.37l-.13.481s-3.032.79-5.932.899c-2.9.108-3.791-.217-3.791-.217s-1.38-.945-1.815-2.51c-.434-1.564-.814-2.075-.13-3.422.684-1.347 1.673-2.857 1.673-2.857z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.363 22.47l.084.639-.864.095-.103-.572.883-.162z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.42 22.905c.293.077.338.794.174 1.011l-.004.004h-2.98c-.064-.139-.002-.532.297-.716.252-.154 1.013-.232 1.62-.27l.012.02s.24.127.534.089c.287-.038.346-.135.347-.138z"
        fill="#4655A1"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.376 23.92h-.766c-.064-.139-.117-.501.182-.685.074-.046.309-.116.456-.149a.946.946 0 01.128.834z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.67 23.717a.495.495 0 01-.076.199l-.004.004h-2.98a.398.398 0 01-.018-.203h3.078z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.069 15.486s.26.37-.022 1c-.282.63-1.829 2.89-1.437 4.108.391 1.217 1.09 3.3 2.393 3.713 1.304.413 7.127-.326 7.127-.326s.239 1.13-1.37 1.152c-1.607.021-5.605.347-6.756-.478-1.152-.826-3.064-4.107-2.999-4.802.066-.695 3.064-4.367 3.064-4.367z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.059 24.527c-.135.292-.473.594-1.298.606-1.386.018-4.549.263-6.132-.199 1.98.17 5.458-.013 7.43-.407z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.023 19.18h8.408c.389.091 1.72 1.405 1.923 2.28-1.774.447-7.436 1.292-9.777 1.163 1.296-1.52-.574-2.434-.554-3.443z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.374 22.591c-.176.011-.347.02-.512.028a2.452 2.452 0 01-.165-.866c0-1.77 2.148-2.83 4.796-2.366 1.285.225 2.452.768 3.313 1.47a7.16 7.16 0 00-2.913-1.203c-2.55-.447-4.62.573-4.62 2.28.001.22.036.44.1.657z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.392 12.263h4.86a1.34 1.34 0 011.336 1.337v4.049a1.34 1.34 0 01-1.336 1.336h-4.86v-6.722z"
        fill="#ED1C24"
      />
      <Path d="M20.392 12.263h.217v6.722h-.217v-6.722z" fill="#C61D23" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.392 12.263h4.86c.246 0 .477.068.675.185h-5.535v-.185z"
        fill="#F58466"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.208 18.58c-.243.25-.582.405-.956.405h-4.86v-.405h5.816z"
        fill="#C61D23"
      />
      <Path d="M20.392 13.964h6.196v.243h-6.196v-.243z" fill="#C61D23" />
      <Path d="M16.023 18.865h8.408v.315h-8.408v-.315z" fill="#ED1C24" />
      <Path d="M16.023 19.093h8.408v.087h-8.408v-.087z" fill="#C61D23" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.023 18.865h4.065V17.8c0-.221-.18-.417-.401-.402l-2.93.196c-.403.026-.734.33-.734.733v.538z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.703 17.397h-.017l-2.93.197c-.402.026-.733.33-.733.733v.084a3.52 3.52 0 003.68-1.014z"
        fill="#302120"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.691 23.4a.772.772 0 010 1.542l-3.602.144a.918.918 0 110-1.83l3.602.145z"
        fill="#5F6567"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.415 15.518s.195 1.6-.407 2.072c-.604.471-4.04.348-4.35.3 0 0 .258.696.459 2.039.2 1.342.344 2.564.344 2.564-.186.187-.801.302-1.096.202 0 0-1.332-4.591-1.303-5.282.029-.69.411-.938 1.215-1.058.804-.12 3.5-.534 3.5-.534l1.638-.303z"
        fill="#4655A1"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.711 12.845c.094-.035.189-.058.284-.07l-.021.003a2.51 2.51 0 00-.071 2.389 1.21 1.21 0 01-.348-.127 2.775 2.775 0 01.064-2.156c.03-.014.06-.027.092-.039z"
        fill="#DDE0E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.974 12.778a1.211 1.211 0 11-.071 2.389 2.512 2.512 0 01.071-2.388z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.322 13.721a1.212 1.212 0 01-1.419 1.446 2.51 2.51 0 01-.264-.992 4.17 4.17 0 001.024-.165c.25-.077.47-.178.66-.289z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.558 14.514a.27.27 0 01.126.032l.744.377-.223.484-.76-.386a.266.266 0 01.113-.507z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.839 10.024c.318.315.902 1.002 1.088 1.95.262 1.328.943 4.164.943 4.164s-.776.207-1.879.206c-1.102-.001-1.4-.496-1.4-.496s-.228-2.422-.339-3.547c-.11-1.124.369-1.586.369-1.586l.833-.733c.208-.183.17-.17.385.042z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.727 9.904l.226.162c-.413.347-1.322.87-1.775 1.424 0 0-.129-.484.221-.808.263-.243.822-.6 1.085-.764.14-.087.117-.105.243-.014z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.468 13.454c-.064.05-2.48.989-2.869.985-.336-.004-.39-.053-.567-.023-.176.03-.359.034-.617.203-.259.17-.175.408-.146.416.03.008.028-.108.104-.209.076-.1.359-.16.359-.16s-.216.065-.28.193c-.063.128-.012.396.036.39.049-.005.015-.169.054-.25.038-.08.273-.232.273-.232s-.182.157-.199.3c-.017.142.082.32.116.278.034-.041-.023-.245.012-.33.035-.085.189-.13.189-.13s-.122.058-.148.164a.51.51 0 00.04.319c.037.053.029-.123.095-.252.066-.128.28-.159.28-.159s.16-.016.252.091c.092.108.245.118.385-.007s.409-.22.588-.258c.18-.039 2.218-.344 2.494-.495.277-.151.904-1.496.904-1.496l-.94-.33-.415.992z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.295 14.89a.266.266 0 110 .533.266.266 0 010-.533z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.47 10.912c1.209-.097.516 2.279.424 2.52l-1.38-.39c.046-.548.284-2.075.957-2.13z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.444 20.293c-1.82-.823-4.84-.913-5.464.684 1.04-1.404 4.566-.887 5.464-.684zM5.641 22.126c.77-.715 1.41-1.05 2.173-1.3a3.28 3.28 0 00-2.173 1.3z"
        fill="#F58466"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.123 18.667c.122.07.165.226.096.348l-.391.69a.256.256 0 01-.348.096.256.256 0 01-.096-.348l.39-.69a.256.256 0 01.349-.096z"
        fill="#FFCB05"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.216 12.335c.213 0 .414.294.448.657.035.363-.11.657-.323.657-.213 0-.413-.294-.448-.657-.034-.363.11-.657.323-.657z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.325 13.649c-.206-.014-.398-.303-.432-.657-.029-.304.068-.56.226-.635.207.015.398.303.432.657.029.304-.068.56-.226.635z"
        fill="#BCBEC0"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.279 12.992s-.584.224-.655.365c-.07.14-.236.864-.217.912.02.047.103.022.124.022.02 0 .1-.597.193-.803.094-.205.592-.378.592-.378l-.037-.118z"
        fill="#BCBEC0"
      />
      <Circle cx={16} cy={16} r={16} fill="#ED1C24" fillOpacity={0.05} />
    </Svg>
  );
}

export default SvgComponent;
